import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';

import App from './App';
import { SelectionProvider } from './selection/SelectionContext';
import { SessionProvider } from './session/SessionContext';
import { demoTheme } from './theme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={demoTheme}>
      <CssBaseline />
      <BrowserRouter>
        <SessionProvider>
          <SelectionProvider>
            <App />
          </SelectionProvider>
        </SessionProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
